import React from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

//components
import Results from "./Results";
import Home from "./Home";
import ErrorPage from "./ErrorPage";
import Footer from "./shared/Footer";

//styles
import { GlobalStyle } from "./globalStyle";

function App() {
  const logo = "Grey Scraper"
  
  return (
    <Router>
      <GlobalStyle />

      <Switch>
        <Route exact path="/results" >
          <Results  logo={ logo } />
        </Route>
        <Route exact path="/error" >
          <ErrorPage error={200} logo={ logo }/>
        </Route>
        <Route exact path="/">
          <Home logo={ logo } />
        </Route>
        <Route path="*">
          <ErrorPage error={404} logo={ logo }/>
        </Route>
      </Switch>

      <Footer logo={ logo } />

    </Router>
  );
}

export default App;
